import { IRelatedOrdersHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

// Two consumers share the list on the order screen - the invoice card, always mounted, and the
// Related work drawer, mounted on demand - so unmounting one must not clear it for the other.
// The fetch replaces the list and the store drops the ticks when a different order is opened.
export const useRelatedOrders = (id: string | undefined): IRelatedOrdersHook => {
  const { orderStore } = useStore();
  const { relatedOrders, relatedLoading } = orderStore;

  useEffect(() => {
    id && orderStore.getRelatedOrders({ id });
  }, [orderStore, id]);

  return { relatedOrders: Array.from(relatedOrders.values()), relatedLoading };
};
